import { EditorState } from 'draft-js';
import Immutable from 'immutable';

/**
 * @param {EditorState} editorState
 */
export function getSelectedBlocks(editorState) {
	const content = editorState.getCurrentContent();
	const selection = editorState.getSelection();
	const startKey = selection.getStartKey();
	const endKey = selection.getEndKey();

	// 非范围选区优化为 o(1)
	if (startKey === endKey) {
		return Immutable.OrderedMap({
			[startKey]: content.getBlockMap().get(startKey)
		});
	}

	let blockKey = startKey;
	let block = content.getBlockForKey(blockKey);
	let blocks = [[blockKey, block]];

	while (blockKey !== endKey) {
		block = content.getBlockAfter(blockKey);
		if (!block) break;
		blockKey = block.getKey()
		blocks.push([blockKey, block]);
	}

	return Immutable.OrderedMap(blocks);
}



// WEBPACK FOOTER //
// ./lib/helpers/getSelectedBlocks.js